import {combineReducers} from 'lowkey-component';

import appReducer from './appSlice';
import navReducer from './navSlice';
import peopleReducer from './peopleSlice';
import trainingReducer from './trainingSlice';
import voiceReducer from './voiceSlice';

export const rootReducer = combineReducers({
  app: appReducer,
  nav: navReducer,
  people: peopleReducer,
  voice: voiceReducer,
  training: trainingReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
